function Row({ label, value }) {
  if (!value && value !== 0) return null;
  return (
    <div className="flex gap-3 py-2.5 border-b border-[#2e2e2e] last:border-0">
      <span className="text-[#555] text-sm w-28 shrink-0">{label}</span>
      <span className="text-sm text-gray-200 break-words min-w-0">{value}</span>
    </div>
  );
}

function TagList({ items, color = "indigo" }) {
  if (!items || items.length === 0) return null;
  const cls =
    color === "indigo"
      ? "bg-indigo-500/15 text-indigo-300"
      : "bg-purple-500/15 text-purple-300";
  return (
    <div className="flex flex-wrap gap-1.5 mt-1">
      {items.map((t) => (
        <span key={t} className={`text-xs px-2 py-0.5 rounded-full ${cls}`}>
          {t}
        </span>
      ))}
    </div>
  );
}

export default function MetadataCard({ download }) {
  if (!download) return null;
  const d = download;

  const formatDate = (iso) => {
    if (!iso) return null;
    try {
      return new Date(iso).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return iso;
    }
  };

  return (
    <div className="bg-[#1a1a1a] border border-[#2e2e2e] rounded-2xl p-5">
      <h2 className="text-lg font-semibold mb-4">Post Metadata</h2>

      <Row label="Username"  value={d.username ? `@${d.username}` : null} />
      <Row label="Full name" value={d.full_name} />
      <Row
        label="Followers"
        value={
          d.follower_count != null
            ? d.follower_count.toLocaleString()
            : null
        }
      />
      <Row label="Post date" value={formatDate(d.post_date)} />
      <Row label="Likes"     value={d.likes_count != null ? d.likes_count.toLocaleString() : null} />
      <Row label="Comments"  value={d.comments_count != null ? d.comments_count.toLocaleString() : null} />
      <Row label="Location"  value={d.location} />
      <Row label="Music"     value={d.music_track} />
      <Row label="Type"      value={d.content_type} />

      {/* Caption */}
      {d.caption && (
        <div className="py-2.5 border-b border-[#2e2e2e]">
          <span className="text-[#555] text-sm">Caption</span>
          <p className="mt-1.5 text-sm text-gray-200 leading-relaxed whitespace-pre-wrap line-clamp-6">
            {d.caption}
          </p>
        </div>
      )}

      {/* Hashtags */}
      {d.hashtags && d.hashtags.length > 0 && (
        <div className="py-2.5 border-b border-[#2e2e2e]">
          <span className="text-[#555] text-sm">Hashtags</span>
          <TagList items={d.hashtags.map((h) => `#${h}`)} color="indigo" />
        </div>
      )}

      {/* Mentions */}
      {d.mentions && d.mentions.length > 0 && (
        <div className="py-2.5">
          <span className="text-[#555] text-sm">Mentions</span>
          <TagList items={d.mentions.map((m) => `@${m}`)} color="purple" />
        </div>
      )}
    </div>
  );
}
